import { AxiosError, AxiosResponse } from 'axios';
import _ from 'lodash';
import { BSOIError } from 'scbk-services/types/http/bsoi-error';

/**
 * AxiosError를 BSOIError 타입으로 변환하는 헬퍼 함수
 *
 * @param error Axios 요청/응답 중 발생한 에러
 * @returns BSOIError.Error 형태로 캐스팅된 에러
 */
const buildBsoiError = (error: AxiosError): BSOIError.Error => {
    const errorData = error?.response?.data as Record<string, string | BSOIError.ErrorDetails[]>;
    if (_.isEmpty(errorData)) {
        return error as BSOIError.Error;
    }
    return error as BSOIError.Error;
};

/**
 * BSOI API 응답을 검사하는 공통 유틸
 * @param response AxiosResponse 객체
 * @throws BS
 */
const checkBsoiResponse = (response: AxiosResponse<unknown, unknown>): void => {
    const data = response.data as Record<string, unknown>;
    if (data?.error || data?.errors) {
        throw buildBsoiError(
            new AxiosError(
                'bsoi response error',
                response?.status?.toString(),
                response?.config,
                response?.request,
                response as AxiosResponse<unknown, unknown>,
            ),
        );
    }
};

export { buildBsoiError, checkBsoiResponse };
